<div class="internal-server-error">
    <div class="no-internet-main">
    <div class="no-internet">
        <div class="graphic-holder">
                <img src="https://static.jiocloud.com/web2.0/common/images/no-internet-2.svg" class="img-fluid img-responsive graphic-back" />
                <img src="https://static.jiocloud.com/web2.0/common/images/no-internet-1.svg" class="img-fluid img-responsive graphic-front mover" />
            </div>
            <div class="error-msg-holder mt-4">
                <h1>Whoops</h1>
                <p>Unable to reach the cloud. Please try after sometime.</p>
            </div>
        </div>

    </div>
</div>